/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-use-before-define */
import localforage from 'localforage'
import { apiConfig } from '@/configs/appConfig'
export const localInstance = localforage.createInstance({
  name: apiConfig.appName,
  storeName: 'smartbook'
});

export const set = async (key: string, value: any) => {
  await localInstance
    .setItem(key, value)
    .catch((error) => console.error('Error storing data:', error))
}
export const get = async (key: string) => {
  const data = await localInstance.getItem(key)
  return data
}

export const remove = async (key: string) => {
  await localInstance
    .removeItem(key)
    .catch((error) => console.error('Error storing data:', error))
}
